/**
 * MarketplaceShell — layout adaptativo para páginas públicas do marketplace.
 *
 * - Usuário autenticado: renderiza o AppShell completo (sidebar + navbar do produto)
 * - Usuário anônimo: renderiza só a PublicNavbar (sem sidebar, sem login obrigatório)
 */
import { Outlet } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../hooks/useAuth';
import AppShell from './AppShell';
import PublicNavbar from './PublicNavbar';

function FullPageSpinner() {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
      <CircularProgress />
    </Box>
  );
}

export default function MarketplaceShell() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) return <FullPageSpinner />;

  // Autenticado: usa o AppShell com sidebar completa
  if (isAuthenticated) return <AppShell />;

  // Anônimo: layout público minimalista
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <PublicNavbar />
      <Outlet />
    </Box>
  );
}
